import { CustomModal } from "../../lib/CustomModal";
import { Input, Form, Button, Row } from "antd";
import { useCallback } from "react";
import { useToggleStatus } from "./hooks/useToggleStatus";

type ReasonModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isBlock: boolean;
  userId: string | null;
  reloadData: () => void;
};

const { TextArea } = Input;

export const ReasonModal = ({
  isModalOpen,
  setIsModalOpen,
  isBlock,
  userId,
  reloadData,
}: ReasonModalProps) => {
  const [form] = Form.useForm();

  const close = useCallback((): void => {
    setIsModalOpen(false);
    form.resetFields();
  }, [form, setIsModalOpen]);

  const { isLoading, onSubmit } = useToggleStatus(
    userId,
    form,
    isBlock,
    setIsModalOpen,
    reloadData
  );

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      titleText={`Specify the reason for ${
        isBlock ? "blocking" : "unblocking"
      }`}
      width={396}
      headerClass="mr-3 text w-500"
      modalClass="reason-modal"
    >
      <div className="mt-8">
        <p className="my-0">{`${
          isBlock ? "Blocking" : "Unblocking"
        } reason will be sent to the user via email.`}</p>
        <div className="mt-6">
          <Form
            layout="vertical"
            autoComplete="off"
            requiredMark={false}
            onFinish={onSubmit}
            disabled={isLoading}
            form={form}
          >
            <Form.Item
              name="reason"
              label={`${isBlock ? "Blocking" : "Unblocking"} reason`}
              className="mb-5"
              rules={[
                {
                  required: true,
                  validateTrigger: "onSubmit",
                },
              ]}
            >
              <TextArea rows={2} />
            </Form.Item>

            <Form.Item className="mt-8 mb-0">
              <Row className="justify-end mt-8 mb-0">
                <Button shape="round" className="mr-2" onClick={close}>
                  Cancel
                </Button>
                <Button
                  type="primary"
                  shape="round"
                  htmlType="submit"
                  loading={isLoading}
                >
                  Submit
                </Button>
              </Row>
            </Form.Item>
          </Form>
        </div>
      </div>
    </CustomModal>
  );
};
